// Roundly's price list (Liam, 12 Oct 2026; ~/Desktop/Sites/roundly-PRICING.md and the terms): one monthly price for a
// whole round, every worker included, set by its active customers. Billing stage 2, docs/plans/billing/PLAN.md. One
// copy for the server (GET /api/business/plan, later billing) and the phone (Your plan, web only).
//
// UK rounds, in pounds, VAT not added (Roundly isn't VAT registered). Over 1,500: a price agreed with Liam, £49.99
// until then (the private guide, never shown: £79.99 to 3,000, from £99.99 over).

export type BandKey = 'starter' | 'growing' | 'established' | 'business' | 'agreed'
export interface Band {
  key: BandKey
  name: string
  from: number
  to: number | null
  pence: number
}

export const BANDS: readonly Band[] = [
  { key: 'starter', name: 'Starter', from: 1, to: 50, pence: 999 },
  { key: 'growing', name: 'Growing', from: 51, to: 200, pence: 1499 },
  { key: 'established', name: 'Established', from: 201, to: 500, pence: 1999 },
  { key: 'business', name: 'Business', from: 501, to: 1500, pence: 4999 },
]
export const OVER_TOP_BAND: Band = { key: 'agreed', name: 'Over 1,500', from: 1501, to: null, pence: 4999 }

// The band for a count. A round with no active customers yet is a Starter round.
export function bandFor(active: number): Band {
  return BANDS.find((b) => b.to !== null && active <= b.to) ?? OVER_TOP_BAND
}

// "£19.99"
export function poundsWords(pence: number): string {
  return `£${Math.floor(pence / 100)}.${String(pence % 100).padStart(2, '0')}`
}

// "1 to 50", "501 to 1,500", "Over 1,500"
export function bandRangeWords(b: Band): string {
  const n = (v: number): string => v.toLocaleString('en-GB')
  return b.to === null ? `Over ${n(b.from - 1)}` : `${n(b.from)} to ${n(b.to)}`
}
